import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import API_URL from "../api/apiUrl";

const ProtectedRoute = ({ children, requireAdmin = false, requireEditor = false }) => {
  const [isChecking, setIsChecking] = useState(true);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const token = localStorage.getItem("token");

  useEffect(() => {
    const verifyAccess = async () => {
      if (!token) {
        setIsChecking(false);
        return;
      }

      if (requireAdmin || requireEditor) {
        try {
          const response = await fetch(`${API_URL}api/verifytoken`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Talent-Track ${token}`,
            },
          });

          if (response.ok) {
            const data = await response.json();
            // allow different roles depending on whether editor access is required
            if (requireEditor) {
              setIsAuthorized(data.role === "admin" || data.role === "auditor");
            } else {
              // for pages that require admin-style access but allow viewing, permit admin, auditor, and reviewer
              setIsAuthorized(data.role === "admin" || data.role === "auditor" || data.role === "reviewer");
            }
          } else {
            setIsAuthorized(false);
          }
        } catch (error) {
          setIsAuthorized(false);
        }
      } else {
        setIsAuthorized(true);
      }
      
      setIsChecking(false);
    };

    verifyAccess();
  }, [token, requireAdmin]);

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (isChecking) {
    return <div>Loading...</div>;
  }

  if (requireAdmin && !isAuthorized) {
    return <Navigate to="/404" replace />;
  }

  return children;
};

export default ProtectedRoute;
